(() => {
  if (window.__tstQuickAdd) return;
  window.__tstQuickAdd = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const MQ = window.matchMedia('(max-width: 749px)');
  const CART = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h9.2a1 1 0 0 0 1-.8L20 8H6.2"/></svg>';
  const CHECK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12 5 5L20 7"/></svg>';
  const SWATCH = {
    'black': '#1b1a17', 'navy': '#26324d', 'sand': '#d8c7a8', 'sport grey': '#a9a9a6', 'sport gray': '#a9a9a6',
    'white': '#ffffff', 'grey': '#9e9e9e', 'gray': '#9e9e9e', 'heather grey': '#b5b5b5', 'dark heather': '#4a4a4a',
    'charcoal': '#3d3d3d', 'ash': '#d7d7d2', 'natural': '#efe6d2', 'red': '#b3261e', 'maroon': '#6b1f2a',
    'pink': '#f2b8c6', 'light pink': '#f6d1dc', 'green': '#2f5d3a', 'forest green': '#2f4a34', 'military green': '#5b5f3c',
    'royal': '#2b4ea2', 'royal blue': '#2b4ea2', 'light blue': '#a9c7e8', 'brown': '#5a3e2b', 'orange': '#e0702b',
    'purple': '#5b3f8c', 'yellow': '#f2c94c', 'cream': '#f3ead8'
  };

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const withParam = (url, param) => url ? url + (url.indexOf('?') > -1 ? '&' : '?') + param : '';
  const money = (cents) => {
    const fmt = String(window.tstMoneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
    const v = Number(cents) / 100;
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return Math.round(v).toLocaleString('en-US');
      if (k === 'amount_with_comma_separator') return v.toFixed(2).replace('.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return Math.round(v).toLocaleString('de-DE');
      return v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  };
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };

  /* ---------- product data (loaded on demand) ---------- */
  const cache = {};
  const getData = (card) => {
    const h = card.dataset.handle;
    if (!cache[h]) {
      cache[h] = fetch(root + 'products/' + h + '.js')
        .then((r) => { if (!r.ok) throw new Error('load'); return r.json(); })
        .then((p) => ({
          options: (p.options || []).map((o) => (typeof o === 'string' ? o : o.name)),
          variants: p.variants.map((v) => ({ id: v.id, price: v.price, available: v.available, options: v.options }))
        }))
        .catch((e) => { delete cache[h]; throw e; });
    }
    return cache[h];
  };
  const findVariant = (d, sel) => d.variants.find((v) => v.options.every((x, i) => x === sel[i]));
  const cardSel = (card) => [...card.querySelectorAll('[data-tst-opt]')].map((s) => s.value);

  /* ---------- shared option rendering ---------- */
  function isOk(d, sel, i, val) {
    return d.variants.some((v) => v.available && v.options[i] === val && v.options.every((x, j) => j >= i || x === sel[j]));
  }
  function syncSel(d, sel) {
    d.options.forEach((name, i) => {
      if (!isOk(d, sel, i, sel[i])) {
        const values = [...new Set(d.variants.map((v) => v.options[i]))];
        const firstOk = values.find((val) => isOk(d, sel, i, val));
        if (firstOk !== undefined) sel[i] = firstOk;
      }
    });
  }
  function optsHTML(d, sel) {
    return d.options.map((name, i) => {
      const values = [...new Set(d.variants.map((v) => v.options[i]))];
      const isColor = /colou?r/i.test(name);
      const chips = values.map((val) => {
        const on = sel[i] === val ? ' is-on' : '';
        const dis = isOk(d, sel, i, val) ? '' : ' disabled';
        const hex = isColor ? SWATCH[String(val).toLowerCase()] : null;
        if (hex) {
          return '<button type="button" class="tst-chip tst-chip--sw' + on + '" style="--sw:' + hex + '" data-tst-chip data-i="' + i + '" data-v="' + esc(val) + '" aria-label="' + esc(val) + '" title="' + esc(val) + '"' + dis + '></button>';
        }
        return '<button type="button" class="tst-chip' + on + '" data-tst-chip data-i="' + i + '" data-v="' + esc(val) + '"' + dis + '>' + esc(val) + '</button>';
      }).join('');
      return '<div class="tst-sheet__label">' + esc(name) + ': <span>' + esc(sel[i]) + '</span></div><div class="tst-sheet__chips">' + chips + '</div>';
    }).join('');
  }
  function setAddButton(btn, v) {
    btn.classList.remove('is-added');
    if (v && v.available) {
      btn.disabled = false;
      btn.innerHTML = CART + 'Add to cart · ' + esc(money(v.price));
    } else {
      btn.disabled = true;
      btn.textContent = 'Sold out';
    }
  }

  /* ---------- cart ---------- */
  async function refreshCartUI() {
    if (document.querySelector('m-cart-items')) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      return;
    }
    try {
      const res = await fetch(root + '?sections=cart-count');
      const json = await res.json();
      const doc = new DOMParser().parseFromString(json['cart-count'], 'text/html');
      document.querySelectorAll('m-cart-count').forEach((el) => {
        if (typeof el.onUpdate === 'function') el.onUpdate(doc);
        else { const n = doc.querySelector('m-cart-count'); if (n) { el.innerHTML = n.innerHTML; el.classList.remove('m:hidden'); } }
      });
    } catch (e) { /* ignore */ }
  }

  async function addToCart(id, btn) {
    btn.classList.add('is-loading');
    btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }] })
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
      refreshCartUI();
      return { ok: true };
    } catch (e) {
      return { ok: false, message: e.message };
    } finally {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  }

  /* ---------- desktop card ---------- */
  async function updateCard(card) {
    try {
      const d = await getData(card);
      const v = findVariant(d, cardSel(card));
      const btn = card.querySelector('[data-tst-add]');
      const from = card.querySelector('.tst-card__from');
      if (from) from.remove();
      if (v) {
        card.querySelector('[data-tst-price]').textContent = money(v.price);
        btn.disabled = !v.available;
        btn.setAttribute('aria-label', v.available ? 'Add to cart' : 'Sold out');
        btn.title = v.available ? '' : 'Sold out';
      } else {
        btn.disabled = true;
        btn.title = 'Unavailable';
      }
    } catch (e) { /* ignore */ }
  }

  document.addEventListener('change', (e) => {
    const s = e.target.closest && e.target.closest('[data-tst-opt]');
    if (s) updateCard(s.closest('[data-tst-card]'));
  });

  document.addEventListener('mouseover', (e) => {
    const card = e.target.closest && e.target.closest('[data-tst-card]');
    if (card && !MQ.matches) getData(card).catch(() => {});
  }, { passive: true });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest && e.target.closest('[data-tst-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const card = btn.closest('[data-tst-card]');
    let d;
    try { d = await getData(card); } catch (err) { window.location.href = card.querySelector('a').href; return; }
    if (card.hasAttribute('data-tst-inline-opts') && d.variants.length > 1) { toggleInline(card, d); return; }
    if (MQ.matches && d.variants.length > 1) { openSheet(card, d); return; }
    const v = d.variants.length === 1 ? d.variants[0] : findVariant(d, cardSel(card));
    if (!v || !v.available) return;
    const r = await addToCart(v.id, btn);
    if (r.ok) {
      const old = btn.innerHTML;
      btn.classList.add('is-added');
      btn.innerHTML = CHECK;
      setTimeout(() => { btn.classList.remove('is-added'); btn.innerHTML = old; }, 1500);
    } else {
      alert(r.message);
    }
  }, true);

  /* ---------- inline options (cart drawer upsell) ---------- */
  function closeAllInline(except) {
    document.querySelectorAll('[data-tst-inline]').forEach((el) => {
      const c = el.closest('[data-tst-card]');
      if (c === except) return;
      if (c) {
        c.classList.remove('is-open');
        const b = c.querySelector('[data-tst-add]');
        if (b) b.textContent = '+ Add';
      }
      el.remove();
    });
  }
  function toggleInline(card, d) {
    const existing = card.querySelector('[data-tst-inline]');
    closeAllInline(card);
    const btn = card.querySelector('[data-tst-add]');
    if (existing) {
      existing.remove();
      card.classList.remove('is-open');
      if (btn) btn.textContent = '+ Add';
      return;
    }
    const first = d.variants.find((v) => v.available) || d.variants[0];
    card._tst = { d, sel: [...first.options] };
    const box = document.createElement('div');
    box.className = 'tst-inline';
    box.setAttribute('data-tst-inline', '');
    box.innerHTML = '<div class="tst-inline__opts"></div><button type="button" class="tst-inline__add" data-tst-inline-add></button><div class="tst-inline__err" hidden></div>';
    card.appendChild(box);
    card.classList.add('is-open');
    if (btn) btn.textContent = 'Close';
    renderInline(card);
  }
  function renderInline(card) {
    const st = card._tst;
    const box = card.querySelector('[data-tst-inline]');
    if (!st || !box) return;
    syncSel(st.d, st.sel);
    box.querySelector('.tst-inline__opts').innerHTML = optsHTML(st.d, st.sel);
    const v = findVariant(st.d, st.sel);
    setAddButton(box.querySelector('[data-tst-inline-add]'), v);
    const priceEl = card.querySelector('.tst-up__price');
    if (priceEl && v) priceEl.textContent = money(v.price);
  }
  document.addEventListener('click', async (e) => {
    const box = e.target.closest && e.target.closest('[data-tst-inline]');
    if (!box) return;
    const card = box.closest('[data-tst-card]');
    const chip = e.target.closest('[data-tst-chip]');
    if (chip) {
      e.preventDefault();
      if (chip.disabled || !card._tst) return;
      card._tst.sel[+chip.dataset.i] = chip.dataset.v;
      renderInline(card);
      return;
    }
    const addB = e.target.closest('[data-tst-inline-add]');
    if (addB) {
      e.preventDefault();
      const v = findVariant(card._tst.d, card._tst.sel);
      if (!v || !v.available) return;
      const err = box.querySelector('.tst-inline__err');
      err.hidden = true;
      const r = await addToCart(v.id, addB);
      if (r.ok) {
        addB.classList.add('is-added');
        addB.innerHTML = CHECK + 'Added';
      } else {
        err.textContent = r.message;
        err.hidden = false;
      }
    }
  });

  /* ---------- bottom sheet (mobile product cards) ---------- */
  let sheet = null;
  let cur = null;

  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'tst-sheet';
    sheet.innerHTML =
      '<div class="tst-sheet__overlay" data-tst-close></div>' +
      '<div class="tst-sheet__panel" role="dialog" aria-modal="true" aria-label="Choose options">' +
      '<div class="tst-sheet__handle"></div>' +
      '<div class="tst-sheet__head"><img class="tst-sheet__img" alt=""><div class="tst-sheet__info"><div class="tst-sheet__title"></div><div class="tst-sheet__price"></div></div>' +
      '<button type="button" class="tst-sheet__x" data-tst-close aria-label="Close"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
      '<div class="tst-sheet__opts"></div>' +
      '<button type="button" class="tst-sheet__add"></button>' +
      '<div class="tst-sheet__error" hidden></div>' +
      '</div>';
    document.body.appendChild(sheet);

    sheet.addEventListener('click', (e) => {
      e.stopPropagation();
      if (e.target.closest('[data-tst-close]')) { closeSheet(); return; }
      const chip = e.target.closest('[data-tst-chip]');
      if (chip && !chip.disabled) { cur.sel[+chip.dataset.i] = chip.dataset.v; renderSheet(); }
    });

    sheet.querySelector('.tst-sheet__add').addEventListener('click', async (e) => {
      const b = e.currentTarget;
      const v = findVariant(cur.d, cur.sel);
      if (!v || !v.available) return;
      const err = sheet.querySelector('.tst-sheet__error');
      err.hidden = true;
      const r = await addToCart(v.id, b);
      if (r.ok) {
        b.classList.add('is-added');
        b.innerHTML = CHECK + 'Added to cart';
        setTimeout(closeSheet, 700);
      } else {
        err.textContent = r.message;
        err.hidden = false;
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet();
    });
  }

  function renderSheet() {
    syncSel(cur.d, cur.sel);
    sheet.querySelector('.tst-sheet__opts').innerHTML = optsHTML(cur.d, cur.sel);
    const v = findVariant(cur.d, cur.sel);
    sheet.querySelector('.tst-sheet__price').textContent = v ? money(v.price) : '';
    setAddButton(sheet.querySelector('.tst-sheet__add'), v);
  }

  function openSheet(card, d) {
    if (!sheet) buildSheet();
    const first = d.variants.find((v) => v.available) || d.variants[0];
    cur = { card, d, sel: [...first.options] };
    sheet.querySelector('.tst-sheet__title').textContent = card.dataset.title || '';
    const img = sheet.querySelector('.tst-sheet__img');
    if (card.dataset.image) { img.src = card.dataset.image; img.hidden = false; } else { img.hidden = true; }
    sheet.querySelector('.tst-sheet__error').hidden = true;
    renderSheet();
    sheet.classList.add('is-open');
    document.documentElement.classList.add('prevent-scroll');
    requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.add('is-visible')));
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.classList.remove('is-visible');
    if (!document.querySelector('.m-cart-drawer--active')) document.documentElement.classList.remove('prevent-scroll');
    setTimeout(() => sheet.classList.remove('is-open'), 280);
  }

  /* ---------- cart drawer upsell ---------- */
  const recCache = {};
  async function fillUpsell(box) {
    if (box.dataset.tstFilled) return;
    box.dataset.tstFilled = '1';
    const pid = box.dataset.productId;
    const list = box.querySelector('[data-tst-upsell-list]');
    if (!pid || !list) return;
    const exclude = String(box.dataset.exclude || '').split(',');
    try {
      if (!recCache[pid]) {
        recCache[pid] = fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8')
          .then((r) => r.json()).then((j) => j.products || [])
          .catch(() => { delete recCache[pid]; return []; });
      }
      const prods = (await recCache[pid]).filter((p) => p.available && exclude.indexOf(String(p.id)) === -1).slice(0, 3);
      if (!prods.length) return;
      list.innerHTML = prods.map((p) => {
        const img = p.featured_image ? withParam(p.featured_image, 'width=160') : '';
        const from = p.price_varies ? '<span class="tst-up__from">From </span>' : '';
        return '<div class="tst-up" data-tst-card data-tst-inline-opts data-handle="' + esc(p.handle) + '" data-title="' + esc(p.title) + '" data-image="' + esc(img) + '">' +
          '<a class="tst-up__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="tst-up__info"><a class="tst-up__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="tst-up__price">' + from + esc(money(p.price_min || p.price)) + '</div></div>' +
          '<button type="button" class="tst-up__add" data-tst-add aria-label="Add ' + esc(p.title) + '">+ Add</button></div>';
      }).join('');
      box.classList.add('is-ready');
    } catch (e) { /* ignore */ }
  }
  let scanQueued = false;
  const scan = () => {
    if (scanQueued) return;
    scanQueued = true;
    requestAnimationFrame(() => {
      scanQueued = false;
      document.querySelectorAll('[data-tst-upsell]:not([data-tst-filled])').forEach(fillUpsell);
    });
  };
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();

  /* ---------- predictive search ---------- */
  document.addEventListener('input', debounce(async (e) => {
    const input = e.target.closest && e.target.closest('.tst-search__input');
    if (!input) return;
    const form = input.closest('[data-tst-search]');
    const box = form.querySelector('.tst-search__results');
    const q = input.value.trim();
    if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
    try {
      const url = form.dataset.suggest + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      const json = await (await fetch(url)).json();
      if (input.value.trim() !== q) return;
      const items = (json.resources && json.resources.results && json.resources.results.products) || [];
      const all = '<a class="tst-search__all" href="' + form.getAttribute('action') + '?type=product&q=' + encodeURIComponent(q) + '">See all results</a>';
      box.innerHTML = items.length
        ? items.map((p) => {
            const img = p.image ? '<img src="' + esc(withParam(p.image, 'width=96')) + '" alt="" loading="lazy">' : '';
            const pr = p.price_min || p.price;
            const priceHtml = pr ? '<b>' + esc(money(Math.round(parseFloat(pr) * 100))) + '</b>' : '';
            return '<a class="tst-search__item" href="' + esc(p.url) + '">' + img + '<span>' + esc(p.title) + '</span>' + priceHtml + '</a>';
          }).join('') + all
        : '<div class="tst-search__empty">No designs found</div>';
      box.hidden = false;
    } catch (err) { /* ignore */ }
  }, 250));

  document.addEventListener('click', (e) => {
    document.querySelectorAll('[data-tst-search] .tst-search__results:not([hidden])').forEach((box) => {
      if (!box.closest('[data-tst-search]').contains(e.target)) box.hidden = true;
    });
  });
})();
